import { memo } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRightIcon } from "lucide-react";
import { Campaign } from "@/types/types";
import { isEveCampaign } from "@/lib/eve";
import { ScopeWrapper } from "@/components/ui/scope-wrapper";

interface CampaignColumnCellProps {
  campaign: Campaign | null;
}

/**
 * Global CRM only: which campaign the row lives in — platform mark + name,
 * linking into that campaign's own creators table.
 */
function CampaignColumnCell({ campaign }: CampaignColumnCellProps) {
  if (!campaign) {
    return <span className="text-muted-foreground text-xs italic pl-2">unknown</span>;
  }
  return (
    <ScopeWrapper className="max-w-full w-full">
      <Link
        to={`/dashboard/campaigns/${campaign._id}/creators`}
        title={`Open ${campaign.campaign_name}`}
        className="group flex h-10 max-w-full items-center gap-2 rounded-md pl-2 pr-2 hover:bg-muted-foreground/10 transition-colors"
      >
        <span className="flex min-w-0 flex-col items-start leading-tight">
          <span className="max-w-full truncate text-sm font-medium">{campaign.campaign_name}</span>
          <span className="max-w-full truncate font-mono text-[10px] uppercase text-muted-foreground">
            {isEveCampaign(campaign) ? "Amy" : "Legacy"} / {campaign.platform}
            {campaign.archived ? " · archived" : ""}
          </span>
        </span>
        <ArrowUpRightIcon className="ml-auto size-3 shrink-0 opacity-0 transition-all group-hover:translate-x-0.75 group-hover:-translate-y-0.75 group-hover:opacity-100" />
      </Link>
    </ScopeWrapper>
  );
}

export default memo(CampaignColumnCell);
